export default __webpack_public_path__ + "static/media/avatar.edaeeddf.png";